import blisterIcon from '../../assets/images/blister-filled.png';
import boxIcon from '../../assets/images/box-filled.png';
import displayIcon from '../../assets/images/display-filled.png';
import pillIcon from '../../assets/images/pill-filled.png';
import { BoniConfigProps, LevelNames } from './interfaces';

export const levelNames = ['Comprimido', 'Blister', 'Caixa', 'Display'] as const;

export const BONI_CONFIG: Record<LevelNames, BoniConfigProps> = {
	Comprimido: {
		icon: pillIcon,
		color: '--spring-green700',
		percentage: 0.04,
	},
	Blister: {
		icon: blisterIcon,
		color: '--electric-violet500',
		percentage: 0.04,
	},
	Caixa: {
		icon: boxIcon,
		color: '#0A7DA9',
		percentage: 0.06,
	},
	Display: {
		icon: displayIcon,
		color: '--royal-blue500',
		percentage: 0.08,
	},
};

export function calculateBoniPoints(levelName?: LevelNames, value = 0) {
	if (!levelName) return 0;

	return value * BONI_CONFIG[levelName].percentage;
}

export function truncateBoniPoints(points: number) {
	return Math.trunc(points * 100) / 100;
}

export function formatBoniPoints(points: number) {
	return new Intl.NumberFormat('pt-BR', {
		minimumFractionDigits: 0,
		maximumFractionDigits: 2,
	}).format(truncateBoniPoints(points));
}

export function calculateBoniPointsDelta({
	levelName,
	oldUnitPrice,
	oldQuantity,
	newProductValue,
	totalLiquid,
}: {
	levelName?: LevelNames;
	oldUnitPrice: number;
	oldQuantity: number;
	newProductValue?: number;
	totalLiquid?: number;
}) {
	const freshBoniPoints = truncateBoniPoints(calculateBoniPoints(levelName, newProductValue));

	const oldProductLineValue = oldUnitPrice * oldQuantity;
	const oldProductBoniPoints = truncateBoniPoints(calculateBoniPoints(levelName, oldProductLineValue));

	const currentTotalPoints = truncateBoniPoints(calculateBoniPoints(levelName, totalLiquid));
	const previousTotalPoints = truncateBoniPoints(currentTotalPoints - (freshBoniPoints - oldProductBoniPoints));

	return { freshBoniPoints, currentTotalPoints, previousTotalPoints };
}
